import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { DownloadHelperService } from 'modules/desktop/services/download-helper.service';
import {Subscription} from "rxjs";
declare var $: any;

import { AppStateHandlerService } from './../../services/app-state-handler.service';

@Component({
    selector: 'app-close-modal',
    styleUrls: ['./app-close-modal.style.scss'],
    templateUrl: './app-close-modal.template.html'
})
export class AppCloseModal implements OnInit {
    
    @ViewChild('closeModal') closeModal: ElementRef;
    downloadInProgress = false;

    private apCloseEventSubscriber: Subscription;
    showAppCloseLoader = false;

    constructor(
        private appStateHandlerService: AppStateHandlerService,
        private chRef: ChangeDetectorRef,
        private downloadHelperService: DownloadHelperService,
    ) { }


    ngOnInit() {
        let self= this;
        this.downloadInProgress = false;
        $('#appCloseModal').on('hidden.bs.modal', this.modalHidehandler);
        this.apCloseEventSubscriber = this.appStateHandlerService.appCloseObservable$.subscribe((options = {}) => {
            self.downloadInProgress = !!options.downloadInProgress;
            this.chRef.detectChanges();
            $('#appCloseModal').modal('show');
        });
    }

    modalHidehandler(){
        this.downloadInProgress = false;
    }

    async quitApp() {
    
    	this.showAppCloseLoader = true;
        await this.downloadHelperService.pauseAllDownloading();
		this.showAppCloseLoader = false;
		
        this.appStateHandlerService.quitApp();
        this.closeModal.nativeElement.click();
    }

    ngOnDestroy(): void {
        $('#appCloseModal').off('hidden.bs.modal', this.modalHidehandler);
        this.apCloseEventSubscriber.unsubscribe();
    }
}